import { AccountPage } from "@common-components/account-page/account-page";
import BTThemeProvider from "@common-components/bt-theme-provider";
import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { selectUserObject } from "@common-reducers/UserSelectors";
import { useState, type ChangeEvent } from "react";
import { useSelector } from "react-redux";
import { SideBarItem } from "@common-components/sidebar/sidebar";
import { User } from "@common/models/user";
import classes from "../account-view/account-view.module.scss";
// import TimezoneSelect, { ITimezone } from "react-timezone-select";
import BTButton from "@common-components/bt-button/bt-button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { useTranslation } from "react-i18next";
import { namespace } from "@common-config/constants";
import { TIME_FORMAT_24H_ENABLED, resolveUses12h, toClockPreference } from "@common/config/time-format";
import { useClockPreference } from "@common/hooks/use-clock-preference";
import { usePatchUserPreferences } from "@common/hooks/use-patch-user-preferences";
export interface AccountLangViewProps { }

export interface AccountLangViewState {
  user?: User | null | undefined;
  loading: boolean;
}

const AccountLangView = () => {
  const { t, i18n } = useTranslation(namespace);
  const user = useSelector(selectUserObject);
  const clockPreference = useClockPreference();
  const patchPreferences = usePatchUserPreferences();
  const [lang, setLang] = useState("");
  const [timezone, setTimezone] = useState("");
  const [time, setTime] = useState(new Date());
  const [date, setDate] = useState(new Date());
  // const [selectedTimezone, setSelectedTimezone] = useState<ITimezone>();

  const langChange = (event: SelectChangeEvent) => {
    setLang(event.target.value as string);
  };
  const timezoneChange = (event: SelectChangeEvent) => {
    setTimezone(event.target.value as string);
  };

  // FE#535 — flag-gated. Off: the radio is inert exactly as before. On: it shows the saved
  // preference (unset = the interface language's own clock) and saves a change to the account.
  const timeFormatValue = resolveUses12h(i18n.language, clockPreference) ? "12-hours" : "24-hours";
  const timeFormatChange = (event: ChangeEvent<HTMLInputElement>) => {
    const next = toClockPreference(event.target.value === "12-hours" ? "12h" : event.target.value === "24-hours" ? "24h" : undefined);
    if (next) void patchPreferences(() => ({ timeFormat: next }));
  };
  const timeFormatGroupProps = TIME_FORMAT_24H_ENABLED
    ? { value: timeFormatValue, onChange: timeFormatChange }
    : {};

  const accountLangView = () => {
    return (
      <div className={classes.pageContainer}>
        <div className={classes.titleContainer}>
          <h4 className={classes.pageTitle}>{t('accountLang.title')}</h4>
        </div>

        <div className={classes.accountSettingBody} style={{
          overflow: 'auto',
        }}>
          <div className={classes.editableField}>
            <span className={classes.fieldName}>{t('accountLang.language')}</span>
            <Select
              style={{ padding: 0, background: "var(--color-surface)" }}
              className={classes.inputField}
              value={lang}
              onChange={langChange}
            >
              <MenuItem selected value={"English"}>
                English
              </MenuItem>
              <MenuItem value={"Português"}>Português</MenuItem>
            </Select>
          </div>{" "}
          <div className={classes.editableField}>
            <span className={classes.fieldName}>{t('accountLang.timezone')}</span>
            <div style={{ padding: 0 }} className={classes.inputField}>
              <Select
                style={{ padding: 0, background: "var(--color-surface)" }}
                className={classes.inputField}
                value={timezone}
                onChange={timezoneChange}
              >
                <MenuItem value={"English"}>Jerusalem (GMT +02:00)</MenuItem>
                <MenuItem value={"Português"}>Português</MenuItem>
              </Select>
            </div>
          </div>
          <div className={classes.editableField}>
            <span className={classes.fieldName}>{t('accountLang.timeFormat')}</span>
            <RadioGroup {...timeFormatGroupProps}>
              <div
                style={{
                  padding: "8px 16px",
                  background: "var(--color-surface)",
                  display: "flex",
                  alignContent: "center",
                }}
                className={classes.inputField}
              >
                <FormControlLabel
                  value="12-hours"
                  control={<Radio />}
                  label={t('accountLang.twelveHours')}
                />
                <span style={{ marginInlineStart: "auto", alignSelf: "center" }}>
                  {time.toLocaleString("en-US", {
                    minute: "2-digit",
                    hour: "2-digit",
                    hour12: true,
                  })}
                </span>
              </div>
              <div
                style={{
                  padding: " 8px 16px",
                  display: "flex",
                  background: "var(--color-surface)",

                  alignContent: "center",
                }}
                className={classes.inputField}
              >
                <FormControlLabel
                  value="24-hours"
                  control={<Radio />}
                  label={t('accountLang.twentyFourHours')}
                />
                <span style={{ marginInlineStart: "auto", alignSelf: "center" }}>
                  {time.toLocaleString("en-US", {
                    minute: "2-digit",
                    hour: "2-digit",
                    hour12: false,
                  })}
                </span>
              </div>
            </RadioGroup>
          </div>
          <div className={classes.editableField}>
            <span className={classes.fieldName}>{t('accountLang.dateFormat')}</span>
            <RadioGroup>
              <div
                style={{
                  background: "var(--color-surface)",
                  display: "flex",
                  alignContent: "center",
                }}
                className={classes.inputField}
              >
                <FormControlLabel
                  value="12-hours"
                  control={<Radio />}
                  label={date.toLocaleString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}
                />
                <span
                  style={{ marginInlineStart: "auto", alignSelf: "center" }}
                ></span>
              </div>
              <div
                style={{
                  padding: "0 16px",
                  background: "var(--color-surface)",
                  display: "flex",
                  alignContent: "center",
                }}
                className={classes.inputField}
              >
                <FormControlLabel
                  value="date2"
                  control={<Radio />}
                  label={date.toLocaleString("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })}
                />
              </div>
            </RadioGroup>
          </div>
          <div
            style={{ alignItems: "flex-end" }}
            className={classes.editableField}
          >
            <BTButton >
            {t('common.saveChanges')}
            </BTButton>
          </div>
        </div>
      </div>
    );
  };

  return (
    <BTThemeProvider>
      <AccountPage
        page={accountLangView()}
      ></AccountPage>
    </BTThemeProvider>
  );
};

export default AccountLangView;
